import { useEffect } from "react";

import { ThemePartial, theme } from "chameleon/lib/theme/theme.css";

import { loadFont } from "checkout-experience/utils/load-font";

export const useRootStyle = (customThemeData: ThemePartial) => {
  useEffect(() => {
    const root = document.querySelector(
      ".checkout-experience" // this is the class added by the design system provider
    ) as HTMLBaseElement;
    if (root) {
      [
        ...Object.values(customThemeData.fontFamilies || {}),
        customThemeData.typography?.fontFamily,
      ]
        .filter((value, index, arr) => arr.indexOf(value) === index)
        .forEach((font) => loadFont({ font }));

      root.style.fontSize = customThemeData.typography?.fontSize
        ? customThemeData.typography?.fontSize + "px"
        : theme.typography?.fontSize;

      root.style.fontFamily =
        customThemeData.typography?.fontFamily ?? theme.typography?.fontFamily;
    }
  }, [customThemeData]);
};
